import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllPatrimonioChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/read/get_all_patrimonio_checklist_maquina_equip_use_case";
import { PatrimonioChecklistMaquinaEquipModel } from "../../models/patrimonio_checklist_maquina_equip";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllPatrimonioChecklistMaquinaEquipUseCase
 */

export class GetAllPatrimonioChecklistMaquinaEquipUseCase
  extends BasePaginatedUseCase<PatrimonioChecklistMaquinaEquipModel>
  implements IGetAllPatrimonioChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllPatrimonioChecklistMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    idPatrimonioMaquinaEquip: number | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllPatrimonioChecklistMaquinaEquip(
      idPatrimonioCentroCusto,
      idPatrimonioMaquinaEquip,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
